module.exports = __webpack_public_path__ + "static/img/u2.21503e4c.png";